import { useEffect, useMemo } from "react";
import { create } from "zustand";
import { Context } from "../core/Context";

type Store = {
  contexts: Record<string, Context | undefined>;
  setContext: (name: string, ctx: Context) => void;
  deleteContext: (name: string) => void;
};

export const useStore = create<Store>((set) => ({
  contexts: {},
  setContext: (id, ctx) => set((s) => ({ contexts: { ...s.contexts, [id]: ctx } })),
  deleteContext: (id) => set((s) => {
    const { [id]: _, ...rest } = s.contexts;
    return { contexts: rest };
  }),
}));

export const useContext = (id: string) => {
  const setContext = useStore((s) => s.setContext);
  const stored = useStore((s) => s.contexts[id]);
  const ctx = useMemo(() => new Context([], id), [id]);

  useEffect(() => {
    if (!stored) {
      setContext(id, ctx); 
    }
  }, [id, stored, ctx, setContext])

  return stored ?? ctx;
};